import { cn } from '@/lib/utils';
import { useInView } from '@/hooks/useInView';

interface AnimateInProps {
  children: React.ReactNode;
  className?: string;
  delay?: number;
  direction?: 'up' | 'left' | 'right';
}

const directionClasses = {
  up: { hidden: 'translate-y-6', visible: 'translate-y-0' },
  left: { hidden: 'translate-x-6', visible: 'translate-x-0' },
  right: { hidden: '-translate-x-6', visible: 'translate-x-0' },
} as const;

export function AnimateIn({
  children,
  className,
  delay = 0,
  direction = 'up',
}: AnimateInProps) {
  const [ref, isInView] = useInView();
  const { hidden, visible } = directionClasses[direction];

  return (
    <div
      ref={ref}
      className={cn(
        'motion-safe:transition-all motion-safe:duration-700 motion-safe:ease-out',
        isInView
          ? `opacity-100 ${visible}`
          : `motion-safe:opacity-0 ${hidden}`,
        className,
      )}
      style={{ transitionDelay: `${delay}ms` }}
    >
      {children}
    </div>
  );
}
